import paymentGatewayApi, { IPaymentGatewayPurchaseParams } from '../api/paymentGatewayApi';
import payment, { product } from '../models/payment';
import creditCard from '../models/creditCard';
import purchaseResponse from '../models/purchaseResponse';
import { IApiResponse } from '../interfaces/IApiResponse';
import { PaymentToken } from 'redhotpie-shared-lib/types/payment';

class PaymentGatewayService {
  getPaymentGateway(): Promise<IApiResponse<any>> {
    return paymentGatewayApi
      .getPaymentGateway()
      .then(res => {
        if (res.success) {
          return { success: true, data: payment.mappingObjects(res.data) };
        }
        return { success: false, data: null };
      })
      .catch(e => {
        console.warn('ERROR: PaymentGatewayService/getPaymentGateway:', e);
        throw new Error('failed');
      });
  }

  async googlePurchase({
    paymentToken,
    token,
    purchaseToken,
  }: {
    paymentToken: string;
    token: string;
    purchaseToken: string;
  }): Promise<any> {
    try {
      const body = {
        Token: {
          Token: paymentToken,
          Type: 'GooglePay',
        } as PaymentToken,
        Product: {
          Token: token,
        },
        PurchaseToken: purchaseToken,
      };
      console.log('payload purchase:', body);
      const res = await paymentGatewayApi.googlePurchase(body);
      return purchaseResponse.mappingPropertyObject(res.data.ResponseStatus || res.data);
    } catch (e) {
      console.warn('ERROR: PaymentGatewayService/paymentGatewayPurchase:', e);
      throw new Error('failed');
    }
  }

  paymentGatewayPurchase(params: IPaymentGatewayPurchaseParams): Promise<any> {
    const objParams: any = {
      Product: {
        Token: params.token,
      },
      UseStoredCard: true,
    };
    if (params.purchaseToken) {
      objParams.PurchaseToken = params.purchaseToken;
    }
    if (params.number) {
      objParams.Card = creditCard.mappingPropertyObject(params);
      objParams.UseStoredCard = false;
    }
    if (params.diamond) {
      delete objParams.UseStoredCard;
      objParams.UseDiamonds = true;
    }
    return paymentGatewayApi
      .paymentGatewayPurchase(objParams)
      .then(res => {
        return purchaseResponse.mappingPropertyObject(res.data.ResponseStatus || res.data);
      })
      .catch(e => {
        console.warn('ERROR: PaymentGatewayService/paymentGatewayPurchase:', e);
        throw new Error('failed');
      });
  }

  getActivePurchase(): Promise<IApiResponse<any>> {
    return paymentGatewayApi
      .getActivePurchase()
      .then(res => {
        if (res.success) {
          return {
            success: true,
            data: payment.mappingActivePurchaseArr(res.data.items),
          };
        }
        return { success: false, data: null };
      })
      .catch(e => {
        console.warn('ERROR: PaymentGatewayService/getActivePurchase:', e);
        throw new Error('failed');
      });
  }

  getCreditsPurchase(): Promise<IApiResponse<any>> {
    return paymentGatewayApi
      .getCreditsPurchase()
      .then(res => {
        return {
          success: res.success,
          data: payment.mappingActivePurchaseCredits(res.data),
        };
      })
      .catch(e => {
        console.warn('ERROR: PaymentGatewayService/getCreditsPurchase:', e);
        throw new Error('failed');
      });
  }

  getInfoProduct(params: any): Promise<IApiResponse<any>> {
    return paymentGatewayApi
      .getInfoProduct(params)
      .then(res => {
        return {
          success: res.success,
          data: res.success ? product.mappingObjects(res.data) : null,
          message: res.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: PaymentGatewayService/getInfoProduct:', e);
        throw new Error('failed');
      });
  }
}

export default new PaymentGatewayService();
